<template>
  <section class="special_course padding_top">
    <b-container>
      <b-row class="justify-content-center">
        <b-col xl="5">

          <!-- show title if have title slot tempalte -->
          <div class="section_tittle">
            <slot name="title"/>
          </div>
          <!-- End title -->
        </b-col>
      </b-row>

      <m-contents-wrapper :content-category="contentCategory()" content-type="post" :slicer="slicer">
        <div class="p-0 m-0" slot-scope="{contents,pagination,changePageFunction}">
          <b-row>
            <b-col lg="4" sm="6" class="mt-3" v-for="post in contents" :key="post.id">
              <m-c302 :alt="post.title" :image="post.thumbnail">
                <template #p-1>
                  <div
                      class="
                  align-items-center
                  justify-content-between">
                <span
                    class="badge badge-danger p-2 rounded-pill h6 text-decoration-none"
                    v-if="post.author">
                  {{
                    `${post.author.name} ${post.author.last_name}`
                  }}
                </span>
                    <p class="custom-font-size">تاریخ انتشار: {{ dateConverter(post.created_at) }}</p>
                  </div>
                  <router-link class="text-decoration-none" :to="{ name: 'SinglePost', params: { slug: post.slug } }">
                    <h3 class="text-dark h4">{{ post.title }}</h3></router-link>
                </template>
              </m-c302>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="text-center my-3">
              <m-pagination-400 v-if="havePagination" :meta="pagination" :on-change-page="changePageFunction"/>
            </b-col>

            <slot name="more"/>
          </b-row>
        </div>
      </m-contents-wrapper>


    </b-container>
  </section>
</template>

<script>
import {dateConverter} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import router from "@/router";
import {mapGetters} from "vuex";

export default {
  name: "Posts1",
  props: {
    slicer: {
      default: Infinity
    },
    havePagination: {
      default: true
    },
  },
  data() {
    return {}
  },
  computed: {},
  methods: {
    dateConverter(date) {
      return dateConverter(date, "/");
    },
    contentCategory() {
      const routeCategory = this.$router.currentRoute.query.category
      return routeCategory == undefined ? null : [routeCategory]
    }
  },
};
</script>

<style scoped>

</style>